<template>
  <div class="home">
    <!-- <img alt="logoCosmic" src="../assets/Fondo1.jpg"> -->
    <h2>Bienvenido a Cosmic Contigo WEB</h2>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
export default {
  name: 'Home',
  components: {},
  mounted () {
    this.Default()
  },
  methods: {
    Default () {
      // debugger
      var self = this
      var IdUsuario = self.$route.params.idusuario
      var token = self.$route.params.__token
      console.log('Home')
      console.log(IdUsuario)
      console.log(token)
    }
  }
}
</script>
